module.exports = __webpack_public_path__ + "static/img/laboratory6.aba0f61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory6.jpg
// module id = nJXT
// module chunks = 1